<template>
    <DForm @submit="submitData">
        <div class="order-client-settings">
            <OneWebshopForm
                :errors="errors"
                :one-webshop-settings="orderSettings.OneWebshop"
                :order-recommendation-logic="orderRecommendationLogic"
                :recommendations="recommendations"
                :prepaid-invoice-behavior-types="prepaidInvoiceBehaviorTypes"
                @one-webshop-valid="oneWebshopStatus"
                @one-webshop-data="oneWebshopData"
            />
            <OsaForm
                :errors="errors"
                :osa-settings="orderSettings.OSA"
                @osa-valid="osaStatus"
                @osa-data="osaData"
            />
            <PsaForm
                :psa-settings="orderSettings.PSA"
                @psa-data="psaData"
            />
            <WooCommerceForm
                :errors="errors"
                :woo-commerce-settings="orderSettings.WooCommerce"
                @woo-commerce-valid="wooCommerceStatus"
                @woo-commerce-data="wooCommerceData"
            />
            <WebglobeForm
                :errors="errors"
                :webglobe-settings="orderSettings.Webglobe"
                :prepaid-invoice-behavior-types="prepaidInvoiceBehaviorTypes"
                @webglobe-valid="webglobeStatus"
                @webglobe-data="webglobeData"
            />
        </div>
        <DFormControls
            v-show="(osaValid && wooCommerceValid && oneWebshopValid && webglobeValid) || formIsDirty"
            @submit="submitData"
        />
    </DForm>
</template>

<script setup>
import { computed, ref } from 'vue'
import { route } from '~@/Composables/route'
import OsaForm from '~@/Components/Settings/OrderSettings/Osa/Form'
import PsaForm from '~@/Components/Settings/OrderSettings/Psa/Form'
import WooCommerceForm from '~@/Components/Settings/OrderSettings/WooCommerce/Form'
import OneWebshopForm from '~@/Components/Settings/OrderSettings/OneWebshop/Form'
import WebglobeForm from '~@/Components/Settings/OrderSettings/Webglobe/Form'
import { useForm } from '@inertiajs/vue3'

defineProps({
    orderSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    },
    orderClients: {
        type: Array,
        default: () => { return [] }
    },
    orderRecommendationLogic: {
        type: Object,
        default: () => { return {} }
    },
    recommendations: {
        type: Array,
        default: () => { return [] }
    },
    prepaidInvoiceBehaviorTypes: {
        type: Array,
        default: () => { return [] }
    }
})

const osaValid = ref(false)
const wooCommerceValid = ref(false)
const oneWebshopValid = ref(false)
const webglobeValid = ref(false)

const formData = useForm({
    OSA: {},
    PSA: {},
    WooCommerce: {},
    OneWebshop: {},
    Webglobe: {}
})

const formIsDirty = computed(() =>
    formData.PSA.isDirty || formData.OSA.isDirty || formData.WooCommerce.isDirty || formData.OneWebshop.isDirty || formData.Webglobe.isDirty
)

function osaStatus (osaStatus) {
    osaValid.value = osaStatus
}

function wooCommerceStatus (wooCommerceStatus) {
    wooCommerceValid.value = wooCommerceStatus
}

function oneWebshopStatus (oneWebshopStatus) {
    oneWebshopValid.value = oneWebshopStatus
}

function webglobeStatus (webglobeStatus) {
    webglobeValid.value = webglobeStatus
}

function osaData (osaData) {
    formData.OSA = osaData
}

function wooCommerceData (wooCommerceData) {
    formData.WooCommerce = wooCommerceData
}

function psaData (psaData) {
    formData.PSA = psaData
}

function oneWebshopData (oneWebshopData) {
    formData.OneWebshop = oneWebshopData
}

function webglobeData (webglobeData) {
    formData.Webglobe = webglobeData
}

const submitData = () => {
    formData.post(route('settings.order-settings.store'))
}

</script>

<script>
export default {
    name: 'OrderSettingsCreate'
}
</script>

<style lang="scss" scoped>
.order-client-settings {
    display: grid;
    grid-gap: 25px;
}
</style>
